import { Outlet, useNavigate } from "react-router";
import NavigationBar from "../components/NavigationBar";

const Backbone = () => {
    return (
        <div className="all">
            <NavigationBar />
            <div className="content">
                <Outlet />
            </div>
        </div>
    )
}

export default Backbone;